import { createContext } from 'react';
import { WhoAmIQuery } from '../generated/graphql';

const init: WhoAmIQuery['whoAmI'] = {
  id: '',
  email: '',
  name: '',
  isConfirmed: false,
  level: null,
  isPartnerAccountOwner: false,
  partner: null,
};

export default createContext<[WhoAmIQuery['whoAmI'], (user: WhoAmIQuery['whoAmI']) => void]>([
  init,
  () => ({}),
]);
